// extracted by mini-css-extract-plugin
export default {"section":"styles_section__V9nrS","img":"styles_img__YSFRU","heading":"styles_heading__zpV38","para":"styles_para__Wxqti"};